/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { Dropdown as BasicDropdown } from 'ember-basic-dropdown/components/basic-dropdown';
import { next } from '@ember/runloop';

interface AddActionsPanelItemPopoverArgs {
  title: string;
  description: string;
  buttonText?: string;
  onClose?: () => unknown;
}

export default class AddActionsPanelItemPopover extends Component<AddActionsPanelItemPopoverArgs> {
  dropdown: BasicDropdown | null = null;

  @action
  registerBasicDropdown(dropdown: BasicDropdown) {
    this.dropdown = dropdown;

    // Open the dropdown programmatically.
    // We'd prefer to use the "initiallyOpened" dropdown argument, but it
    // doesn't really work: https://github.com/cibernox/ember-basic-dropdown/issues/614
    next(this, this.dropdown.actions.open);
  }

  // Ember Basic Dropdown only supports above and below positioning by default,
  // but we want to position it to the right, so we need to calculate the
  // position ourselves.
  @action
  calculateDropdownPosition(trigger: HTMLElement, content: HTMLElement) {
    // The dropdown's trigger is invisible and has no height, but we need to offset
    // the top position so that the dropdown's content is centered vertically along
    // the action item.
    let parentHeight = trigger.parentElement?.offsetHeight ?? 0;

    // https://ember-basic-dropdown.com/docs/custom-position
    let { top, left, width } = trigger.getBoundingClientRect();
    let { height: contentHeight } = content.getBoundingClientRect();
    let style = {
      left: left + width,
      top: top + window.pageYOffset - Math.floor(contentHeight / 2) - Math.floor(parentHeight / 2),
    };

    return { style };
  }

  // By default, Ember Basic Dropdown will close on outside clicks, but in this
  // case we want to keep it open unless the close button is explicitly clicked.
  allowClosingDropdown = false;

  @action
  preventDropdownClose() {
    return this.allowClosingDropdown;
  }

  @action
  onClose() {
    this.allowClosingDropdown = true;
    this.dropdown?.actions.close();
    return this.args.onClose?.();
  }

  get buttonText() {
    return this.args.buttonText ?? 'Got it!';
  }
}
